/* ============================================================
   PADELISM — PDP image lightbox + quick-add (colour & size dropdowns)
   v5 22.6.26 · universal colour→image resolver (filename OR alt) ·
   full-screen viewer loads ALL colour slides so you can browse every colour
   ============================================================ */
(function () {
  if (window.__pdpZoomInit) return;
  window.__pdpZoomInit = true;
  var OV_ID = 'pdpZoomOverlay';
  var V = null;

  function hiRes(src) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$12048');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
  }

  function imgFile(u) { return u ? u.split('?')[0].split('/').pop().toLowerCase() : ''; }
  function allPdpSlides() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-gallery-slide')); }
  function resolveSlideIndex(sw) {
    var slides = allPdpSlides(), i, im;
    var c = (sw && (sw.getAttribute('data-value') || '')).toLowerCase().trim();
    if (c) { for (i = 0; i < slides.length; i++) { var alt = (' ' + (slides[i].getAttribute('data-alt') || '').toLowerCase() + ' ').replace(/[^a-z ]+/g, ' '); if (alt.indexOf(' ' + c + ' ') !== -1) return i; } }
    var di = sw && sw.getAttribute('data-img');
    var f = di ? imgFile(di) : '';
    if (f) { for (i = 0; i < slides.length; i++) { im = slides[i].querySelector('img'); if (im && imgFile(im.getAttribute('src') || im.src) === f) return i; } }
    return -1;
  }

  function injectCSS() {
    if (document.getElementById('pdpz-styles')) return;
    var s = document.createElement('style');
    s.id = 'pdpz-styles';
    s.textContent =
      'html.pdpz-lock{overflow:hidden;}' +
      '.pdpz-overlay{position:fixed;inset:0;z-index:100000;background:rgba(0,0,0,.94);display:none;-webkit-user-select:none;user-select:none;}' +
      '.pdpz-overlay.pdpz-open{display:block;}' +
      '.pdpz-viewport{position:absolute;inset:0;overflow:hidden;touch-action:none;}' +
      '.pdpz-track{display:flex;height:100%;will-change:transform;}' +
      '.pdpz-slide{flex:0 0 100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;}' +
      '.pdpz-slide img{max-width:100%;max-height:100%;will-change:transform;-webkit-user-drag:none;user-select:none;pointer-events:none;backface-visibility:hidden;}' +
      '.pdpz-close{position:absolute;top:max(12px,env(safe-area-inset-top));right:14px;z-index:6;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#111;font-size:26px;line-height:44px;text-align:center;cursor:pointer;padding:0;}' +
      '.pdpz-counter{position:absolute;bottom:max(16px,env(safe-area-inset-bottom));left:0;right:0;text-align:center;color:rgba(255,255,255,.85);font-size:13px;letter-spacing:.04em;z-index:3;pointer-events:none;}' +
      '.pdpz-counter.pdpz-hide{display:none;}' +
      '.pdpz-buy{position:absolute;left:0;right:0;bottom:0;z-index:5;background:#fff;padding:10px 12px;padding-bottom:max(10px,env(safe-area-inset-bottom));box-shadow:0 -4px 16px rgba(0,0,0,.18);display:none;}' +
      '.pdpz-overlay.pdpz-has-buy .pdpz-buy{display:block;}' +
      '.pdpz-overlay.pdpz-has-buy .pdpz-counter{display:none;}' +
      '.pdpz-buy-hint{font-size:12px;color:#b00020;margin:0 0 6px;display:none;}' +
      '.pdpz-buy-rows{display:flex;gap:8px;margin-bottom:8px;}' +
      '.pdpz-sel{flex:1;min-width:0;height:46px;border:1px solid #e2e2e2;background:#fff;color:#171717;font-family:inherit;font-size:14px;font-weight:600;padding:0 12px;border-radius:0;}' +
      '.pdpz-buy-add{width:100%;min-height:48px;background:#ff7a00;color:#fff;border:0;font-family:inherit;font-size:16px;font-weight:700;letter-spacing:.02em;text-transform:uppercase;cursor:pointer;border-radius:0;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function buildViewer() {
    injectCSS();
    var ov = document.createElement('div');
    ov.id = OV_ID;
    ov.className = 'pdpz-overlay';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.innerHTML =
      '<button type="button" class="pdpz-close" aria-label="Close">×</button>' +
      '<div class="pdpz-viewport"><div class="pdpz-track"></div></div>' +
      '<div class="pdpz-counter"></div>' +
      '<div class="pdpz-buy"><div class="pdpz-buy-hint">Select a size</div><div class="pdpz-buy-rows"><select class="pdpz-sel pdpz-sel-colour" aria-label="Colour"></select><select class="pdpz-sel pdpz-sel-size" aria-label="Size"></select></div><button type="button" class="pdpz-buy-add">Add to Bag</button></div>';
    document.body.appendChild(ov);

    var viewport = ov.querySelector('.pdpz-viewport');
    var track = ov.querySelector('.pdpz-track');
    var counter = ov.querySelector('.pdpz-counter');
    var buyHint = ov.querySelector('.pdpz-buy-hint');
    var selColour = ov.querySelector('.pdpz-sel-colour');
    var selSizeEl = ov.querySelector('.pdpz-sel-size');
    var buyAdd = ov.querySelector('.pdpz-buy-add');
    var colourEls = [], sizeEls = [];
    var st = { index: 0, n: 0, scale: 1, tx: 0, ty: 0 };
    var g = {};
    var MAX = 4, EASE = 'transform .28s cubic-bezier(.22,.61,.36,1)';

    function vw() { return viewport.clientWidth; }
    function vh() { return viewport.clientHeight; }
    function curImg() { var sl = track.children[st.index]; return sl ? sl.querySelector('img') : null; }
    function setTrack(anim, dragX, dragY) {
      track.style.transition = anim ? EASE : 'none';
      track.style.transform = 'translate3d(' + (-st.index * vw() + (dragX || 0)) + 'px,' + (dragY || 0) + 'px,0)';
    }
    function setImg(anim) {
      var im = curImg(); if (!im) return;
      im.style.transition = anim ? 'transform .25s ease' : 'none';
      im.style.transform = 'translate3d(' + st.tx + 'px,' + st.ty + 'px,0) scale(' + st.scale + ')';
    }
    function clampPan() {
      var im = curImg(); if (!im) return;
      var ox = Math.max(0, (im.clientWidth * st.scale - vw()) / 2);
      var oy = Math.max(0, (im.clientHeight * st.scale - vh()) / 2);
      st.tx = Math.max(-ox, Math.min(ox, st.tx));
      st.ty = Math.max(-oy, Math.min(oy, st.ty));
    }
    function resetZoom(anim) { st.scale = 1; st.tx = 0; st.ty = 0; setImg(anim); }
    function setIndex(i, anim) {
      st.index = Math.max(0, Math.min(st.n - 1, i));
      resetZoom(false); setTrack(anim, 0, 0); updateCounter();
    }
    function updateCounter() {
      counter.textContent = (st.index + 1) + ' / ' + st.n;
      counter.classList.toggle('pdpz-hide', st.n < 2);
    }

    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }

    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        g.mode = 'pinch';
        g.startDist = dist(e.touches);
        g.startScale = st.scale;
        g.startMid = mid(e.touches);
        g.startTx = st.tx; g.startTy = st.ty;
      } else if (e.touches.length === 1) {
        g.mode = null; g.moved = false;
        g.sx = e.touches[0].clientX; g.sy = e.touches[0].clientY;
        g.startTx = st.tx; g.startTy = st.ty;
      }
    }, { passive: false });

    viewport.addEventListener('touchmove', function (e) {
      if (g.mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var ns = Math.max(1, Math.min(MAX, g.startScale * (dist(e.touches) / g.startDist)));
        var m = mid(e.touches), cx = vw() / 2, cy = vh() / 2;
        var ax = g.startMid.x - cx, ay = g.startMid.y - cy;
        st.tx = ax - (ax - g.startTx) * (ns / g.startScale) + (m.x - g.startMid.x);
        st.ty = ay - (ay - g.startTy) * (ns / g.startScale) + (m.y - g.startMid.y);
        st.scale = ns;
        clampPan(); setImg(false);
        return;
      }
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - g.sx, dy = e.touches[0].clientY - g.sy;
      if (!g.mode) {
        if (st.scale > 1) g.mode = 'pan';
        else if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) g.mode = 'swipe';
        else if (dy > 6 && Math.abs(dy) > Math.abs(dx)) g.mode = 'close';
        else return;
      }
      g.moved = true;
      if (g.mode === 'pan') {
        e.preventDefault();
        st.tx = g.startTx + dx; st.ty = g.startTy + dy; clampPan(); setImg(false);
      } else if (g.mode === 'swipe') {
        e.preventDefault();
        var d = dx;
        if ((st.index === 0 && d > 0) || (st.index === st.n - 1 && d < 0)) d *= 0.35;
        setTrack(false, d, 0);
      } else if (g.mode === 'close') {
        e.preventDefault();
        ov.style.background = 'rgba(0,0,0,' + Math.max(0.4, 0.94 - dy / 500) + ')';
        setTrack(false, 0, dy);
      }
    }, { passive: false });

    viewport.addEventListener('touchend', function (e) {
      if (e.touches.length === 1 && st.scale > 1) {
        g.mode = 'pan'; g.sx = e.touches[0].clientX; g.sy = e.touches[0].clientY;
        g.startTx = st.tx; g.startTy = st.ty; return;
      }
      if (e.touches.length > 0) return;
      var ct = e.changedTouches[0];
      if (g.mode === 'swipe') {
        var dx = ct.clientX - g.sx;
        if (dx < -vw() * 0.16 && st.index < st.n - 1) setIndex(st.index + 1, true);
        else if (dx > vw() * 0.16 && st.index > 0) setIndex(st.index - 1, true);
        else setTrack(true, 0, 0);
      } else if (g.mode === 'close') {
        if (ct.clientY - g.sy > 90) { closeViewer(); return; }
        ov.style.background = ''; setTrack(true, 0, 0);
      } else if (g.mode === 'pan' || g.mode === 'pinch') {
        if (st.scale <= 1.02) resetZoom(true);
      } else if (!g.moved) {
        var now = Date.now();
        if (now - (g.lastTap || 0) < 300) {
          if (st.scale > 1) resetZoom(true);
          else {
            st.scale = 2.5;
            st.tx = (ct.clientX - vw() / 2) * (1 - st.scale);
            st.ty = (ct.clientY - vh() / 2) * (1 - st.scale);
            clampPan(); setImg(true);
          }
          g.lastTap = 0;
        } else { g.lastTap = now; }
      }
      g.mode = null;
    });

    ov.querySelector('.pdpz-close').addEventListener('click', closeViewer);
    window.addEventListener('resize', function () { if (ov.classList.contains('pdpz-open')) { resetZoom(false); setTrack(false, 0, 0); } });

    function closeViewer() {
      ov.classList.remove('pdpz-open');
      ov.style.background = '';
      document.documentElement.classList.remove('pdpz-lock');
    }

    function mainSizeBtns() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-size-grid .pdp-size-btn')); }
    function visibleSwatches() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-swatch')).filter(function (s) { return s.offsetParent !== null && s.style.display !== 'none'; }); }
    function swatchName(el) { return (el.getAttribute('data-value') || el.getAttribute('title') || el.getAttribute('aria-label') || el.getAttribute('data-color') || '').trim(); }

    function loadUrls(urls, index) {
      track.style.transition = 'none';
      track.innerHTML = '';
      urls.forEach(function (u) {
        var sl = document.createElement('div'); sl.className = 'pdpz-slide';
        var im = document.createElement('img'); im.alt = ''; im.src = u;
        sl.appendChild(im); track.appendChild(sl);
      });
      st.n = urls.length; st.scale = 1; st.tx = 0; st.ty = 0;
      st.index = Math.max(0, Math.min(st.n - 1, index || 0));
      setTrack(false, 0, 0); updateCounter();
    }

    function populateSize() {
      sizeEls = mainSizeBtns();
      if (!sizeEls.length) { selSizeEl.style.display = 'none'; return; }
      selSizeEl.style.display = '';
      selSizeEl.innerHTML = '';
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Size'; selSizeEl.appendChild(ph);
      var hasActive = false;
      sizeEls.forEach(function (b, i) {
        var o = document.createElement('option'); o.value = String(i);
        o.textContent = b.textContent.trim() + (b.classList.contains('sold-out') ? ' — Sold out' : '');
        if (b.classList.contains('sold-out')) o.disabled = true;
        if (b.classList.contains('active')) { o.selected = true; hasActive = true; }
        selSizeEl.appendChild(o);
      });
      if (!hasActive) selSizeEl.value = '';
    }
    function populateColour() {
      colourEls = visibleSwatches();
      if (colourEls.length < 2) { selColour.style.display = 'none'; return; }
      selColour.style.display = '';
      selColour.innerHTML = '';
      colourEls.forEach(function (sw, i) {
        var o = document.createElement('option'); o.value = String(i);
        o.textContent = swatchName(sw) || ('Colour ' + (i + 1));
        if (sw.classList.contains('active')) o.selected = true;
        selColour.appendChild(o);
      });
    }
    function populateBuy() { ov.classList.add('pdpz-has-buy'); buyHint.style.display = 'none'; populateColour(); populateSize(); }

    selColour.addEventListener('change', function () {
      var sw = colourEls[parseInt(selColour.value, 10)];
      if (!sw) return;
      sw.click();
      setTimeout(function () {
        var ti = resolveSlideIndex(sw);
        if (ti < 0) ti = 0;
        setIndex(ti, true);
        populateSize();
      }, 80);
    });
    selSizeEl.addEventListener('change', function () {
      buyHint.style.display = 'none';
      if (selSizeEl.value === '') return;
      var b = sizeEls[parseInt(selSizeEl.value, 10)]; if (b) b.click();
    });
    buyAdd.addEventListener('click', function () {
      if (sizeEls.length) {
        var b = selSizeEl.value !== '' ? sizeEls[parseInt(selSizeEl.value, 10)] : null;
        if (!b) b = sizeEls.filter(function (x) { return x.classList.contains('active'); })[0];
        if (!b) { buyHint.style.display = 'block'; return; }
        b.click();
      }
      var atc = document.querySelector('.pdp-btn-inline-add') || document.querySelector('.pdp-btn-add-to-cart');
      if (atc) atc.click();
      closeViewer();
    });

    V = {
      open: function (urls, index) {
        ov.classList.add('pdpz-open');
        document.documentElement.classList.add('pdpz-lock');
        loadUrls(urls, index);
        populateBuy();
        requestAnimationFrame(function () { setIndex(st.index, false); });
      }
    };
    return V;
  }

  function viewer() { return V || buildViewer(); }

  function slideFrom(node) { return (node && node.closest) ? node.closest('.pdp-gallery-slide') : null; }
  var lastOpen = 0;
  function openFromSlide(slide) {
    if (!slide) return;
    var now = Date.now(); if (now - lastOpen < 600) return; lastOpen = now;
    var slides = allPdpSlides();
    var idx = slides.indexOf(slide); if (idx < 0) idx = 0;
    var urls = [];
    slides.forEach(function (s) { var im = s.querySelector('img'); if (im) urls.push(hiRes(im.getAttribute('src') || im.src)); });
    if (!urls.length) return;
    viewer().open(urls, idx);
  }

  var tsx = 0, tsy = 0, tst = 0, tracking = false;
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1 || !slideFrom(e.target)) { tracking = false; return; }
    tsx = e.touches[0].clientX; tsy = e.touches[0].clientY; tst = Date.now(); tracking = true;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    if (!tracking) return; tracking = false;
    var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
    if (Math.abs(t.clientX - tsx) > 12 || Math.abs(t.clientY - tsy) > 12) return;
    if (Date.now() - tst > 500) return;
    var slide = slideFrom(t.target);
    if (!slide && document.elementFromPoint) slide = slideFrom(document.elementFromPoint(t.clientX, t.clientY));
    openFromSlide(slide);
  }, { passive: true, capture: true });
  document.addEventListener('click', function (e) {
    var slide = slideFrom(e.target);
    if (slide) openFromSlide(slide);
  }, { capture: true });
})();

/* STICKY ATC REVEAL (mobile) — show the sticky Add-to-Bag immediately on load. */
(function () {
  function reveal() {
    if (window.matchMedia('(min-width: 768px)').matches) return;
    var sticky = document.querySelector('.pdp-sticky-cta');
    var inline = document.querySelector('.pdp-inline-cta');
    if (!sticky || !inline) return;
    var r = inline.getBoundingClientRect();
    if (r.top > window.innerHeight - 40) sticky.classList.remove('pdp-sticky-hidden');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  window.addEventListener('load', reveal);
  setTimeout(reveal, 800);
})();

/* RETURNS WINDOW — surface the 30-day window in the trust row. */
(function () {
  function setReturns() {
    var labels = document.querySelectorAll('.pdp-trust-label');
    for (var i = 0; i < labels.length; i++) {
      var t = labels[i].textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.indexOf('return') !== -1 && t.indexOf('30') === -1) {
        labels[i].innerHTML = 'Free 30-Day<br>Returns';
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setReturns); else setReturns();
  setTimeout(setReturns, 1200);
})();

/* DELIVERY REFRAME — frame the 7-10 day window as made-to-order (premium), not a bare wait. */
(function () {
  function reframe() {
    var el = document.querySelector('.pdp-delivery-estimate span');
    if (!el || /made to order/i.test(el.textContent)) return;
    el.innerHTML = 'Each garment made to order for you — ships in 7–10 days. Free over £75.';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reframe); else reframe();
  setTimeout(reframe, 1200);
})();

/* STICKY ATC — mirror the full-screen experience: COLOUR + SIZE dropdowns (replacing size buttons) + any colour choice changes the hero image, on all products. */
(function () {
  function imgFile(u) { return u ? u.split('?')[0].split('/').pop().toLowerCase() : ''; }
  function allSlides() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-gallery-slide')); }
  function mainSwatches() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-colour-swatches .pdp-swatch')).filter(function (s) { return s.offsetParent !== null && s.style.display !== 'none'; }); }
  function swName(sw) { return (sw.getAttribute('data-value') || sw.getAttribute('title') || sw.getAttribute('aria-label') || '').trim(); }

  function resolveIdx(sw) {
    var sl = allSlides(), i, im;
    var c = (sw && (sw.getAttribute('data-value') || '')).toLowerCase().trim();
    if (c) { for (i = 0; i < sl.length; i++) { var alt = (' ' + (sl[i].getAttribute('data-alt') || '').toLowerCase() + ' ').replace(/[^a-z ]+/g, ' '); if (alt.indexOf(' ' + c + ' ') !== -1) return i; } }
    var di = sw && sw.getAttribute('data-img');
    var f = di ? imgFile(di) : '';
    if (f) { for (i = 0; i < sl.length; i++) { im = sl[i].querySelector('img'); if (im && imgFile(im.getAttribute('src') || im.src) === f) return i; } }
    return -1;
  }

  function goToColour(sw) {
    var sl = allSlides(), idx = resolveIdx(sw);
    if (idx < 0) return;
    if (sl[idx] && sl[idx].style.display === 'none') sl[idx].style.display = '';
    var dot = document.querySelector('.pdp-gallery-dots .pdp-dot[data-i="' + idx + '"]');
    if (dot) { dot.style.display = ''; dot.click(); }
    var track = document.querySelector('.pdp-gallery-track');
    if (track && sl[idx]) { try { track.scrollTo({ left: sl[idx].offsetLeft, behavior: 'smooth' }); } catch (e) {} }
  }

  function syncSticky(sel, sw) {
    if (!sel) return;
    var v = swName(sw).toLowerCase();
    for (var i = 0; i < sel.options.length; i++) { if ((sel.options[i].textContent || '').trim().toLowerCase() === v) { sel.selectedIndex = i; break; } }
  }

  function build() {
    var sticky = document.querySelector('.pdp-sticky-cta');
    if (!sticky) return;
    if (!sticky.querySelector('.pdpz-sticky-rows')) {
      var swatches = mainSwatches();
      var sizeBtns = Array.prototype.slice.call(document.querySelectorAll('.pdp-sticky-sizes .pdp-sticky-size'));
      var row = document.createElement('div');
      row.className = 'pdpz-sticky-rows';
      row.style.cssText = 'display:flex;gap:8px;margin-bottom:8px;';
      var ss = 'flex:1;min-width:0;height:42px;border:1px solid #e2e2e2;background:#fff;color:#171717;font-family:inherit;font-size:14px;font-weight:600;padding:0 10px;border-radius:0;';
      if (swatches.length >= 2) {
        var selC = document.createElement('select');
        selC.className = 'pdpz-sticky-colour'; selC.setAttribute('aria-label', 'Colour'); selC.style.cssText = ss;
        swatches.forEach(function (sw, i) { var o = document.createElement('option'); o.value = String(i); o.textContent = swName(sw) || ('Colour ' + (i + 1)); if (sw.classList.contains('active')) o.selected = true; selC.appendChild(o); });
        selC.addEventListener('change', function () { var s = mainSwatches()[parseInt(selC.value, 10)]; if (!s) return; s.click(); setTimeout(function () { goToColour(s); }, 130); });
        row.appendChild(selC);
      }
      if (sizeBtns.length) {
        var selS = document.createElement('select');
        selS.className = 'pdpz-sticky-size'; selS.setAttribute('aria-label', 'Size'); selS.style.cssText = ss;
        var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Size'; selS.appendChild(ph);
        var hasActive = false;
        sizeBtns.forEach(function (b, i) { var o = document.createElement('option'); o.value = String(i); o.textContent = b.textContent.trim() + (b.classList.contains('sold-out') ? ' — Sold out' : ''); if (b.classList.contains('sold-out')) o.disabled = true; if (b.classList.contains('active')) { o.selected = true; hasActive = true; } selS.appendChild(o); });
        if (!hasActive) selS.value = '';
        selS.addEventListener('change', function () { if (selS.value === '') return; var b = document.querySelectorAll('.pdp-sticky-sizes .pdp-sticky-size')[parseInt(selS.value, 10)]; if (b) b.click(); });
        row.appendChild(selS);
      }
      if (row.children.length) {
        var sizesWrap = document.querySelector('.pdp-sticky-sizes');
        if (sizesWrap && sizesWrap.parentNode) { sizesWrap.style.display = 'none'; sizesWrap.parentNode.insertBefore(row, sizesWrap); }
        else { var topRow = sticky.querySelector('.pdp-sticky-top-row'); if (topRow && topRow.parentNode) topRow.parentNode.insertBefore(row, topRow.nextSibling); else sticky.insertBefore(row, sticky.firstChild); }
      }
    }
    document.querySelectorAll('.pdp-colour-swatches .pdp-swatch').forEach(function (sw) {
      if (sw.dataset.pdpzHero) return; sw.dataset.pdpzHero = '1';
      sw.addEventListener('click', function () {
        setTimeout(function () { goToColour(sw); syncSticky(document.querySelector('.pdpz-sticky-colour'), sw); }, 130);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  setTimeout(build, 900);
  setTimeout(build, 1800);
})();